import React from "react";

const Footer = () => {
 const year = new Date().getFullYear();
 return (
 <div className="footer">
 <div className="copyright">
 <p>
 CX360 © 2026 All Rights Reserved
 </p>
</div>

 </div>
 );
};

export default Footer;
